import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './switch-to-standard-bank.component.scss';
var SwitchToStandardBank = /** @class */ (function (_super) {
    tslib_1.__extends(SwitchToStandardBank, _super);
    function SwitchToStandardBank(element) {
        return _super.call(this, element) || this;
    }
    SwitchToStandardBank.prototype.init = function () { };
    SwitchToStandardBank.prototype.bindEvents = function () { };
    return SwitchToStandardBank;
}(Base));
export { SwitchToStandardBank };



//////////////////
// WEBPACK FOOTER
// ./components/switch-to-standard-bank/switch-to-standard-bank.component.ts
// module id = 525
// module chunks = 0